// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-glass-result-list----styles-module---container---RzwHU","item":"src-page-components-glass-result-list----styles-module---item---1TaTm"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/glass/result-list/styles.module.css
// module id = 650
// module chunks = 85208315989496